import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Shield, Lock, Server, Key } from 'lucide-react';

export default function SecurityPage() {
  const securityMeasures = [
    {
      icon: Shield,
      title: 'Data Encryption',
      description: 'All data is encrypted in transit and at rest using industry-standard AES-256 encryption.'
    },
    {
      icon: Lock,
      title: 'Access Controls',
      description: 'Strict access controls and multi-factor authentication for all system access.'
    },
    {
      icon: Server,
      title: 'Secure Infrastructure',
      description: 'Hosted on enterprise-grade cloud infrastructure with continuous security monitoring.'
    },
    {
      icon: Key,
      title: 'Authentication',
      description: 'Robust authentication mechanisms and session management.'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold mb-8">Security</h1>
          
          <div className="bg-white rounded-lg shadow-sm p-8 space-y-12">
            <section>
              <h2 className="text-2xl font-semibold mb-6">Our Security Commitment</h2>
              <p className="text-gray-600">
                At PQstart, security is our top priority. We implement comprehensive security measures to protect your data 
                and ensure the confidentiality of your privacy assessments.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-6">Security Measures</h2>
              <div className="grid md:grid-cols-2 gap-6">
                {securityMeasures.map((measure, index) => (
                  <div key={index} className="p-6 border border-gray-100 rounded-lg hover:border-brand-primary transition-colors">
                    <div className="flex items-center mb-4">
                      <measure.icon className="h-6 w-6 text-brand-primary mr-3" />
                      <h3 className="text-lg font-semibold">{measure.title}</h3>
                    </div>
                    <p className="text-gray-600">{measure.description}</p>
                  </div>
                ))}
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-6">Security Certifications</h2>
              <p className="text-gray-600 mb-4">
                Our platform maintains compliance with leading security standards and certifications:
              </p>
              <ul className="list-disc list-inside text-gray-600 space-y-2">
                <li>SOC 2 Type II certified</li>
                <li>ISO 27001 certified</li>
                <li>NIST Cybersecurity Framework</li>
                <li>Regular third-party security audits</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-6">Reporting Security Issues</h2>
              <p className="text-gray-600">
                If you discover a security vulnerability, please report it to{' '}
                <a href="mailto:security@pqstart.com" className="text-brand-primary hover:text-brand-dark">
                  security@pqstart.com
                </a>
              </p>
            </section>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}